export const messages = {
  page: {
    title: {
      id: 'acceptTermsOfUse.Page.Title',
      defaultMessage: 'Terms of Use',
    },
  },
};
